import atendimentosService from '@/api/atendimentoModule/atendimentoProfissionalServices'

export default {
  loadTable({ commit }, pageConfig) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .loadTable(pageConfig)
        .then((result) => {
          commit('LOAD_LIST_ATENDIMENTO', result.data.content)
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  prepareToEditAtendimento({ commit }, data) {
    commit('PREPARE_TO_EDIT_ATENDIMENTO', data)
  },
  edit({ commit }, data) {
    return atendimentosService
      .edit(data)
      .then((result) => result)
      .catch((error) => error)
  },
  resetProfession({ commit }) {
    commit('RESET_ATENDIMENTO')
  },
  listaAtendimentoPorIdRegistro({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .listaAtendimentoPorIdRegistro(id)
        .then((result) => {
          commit('LOAD_LIST_ATENDIMENTO', result.data)
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  async searchProfessional({ commit }, search) {
    try {
      const result = await atendimentosService.searchProfessional(search)
      return result
    } catch (error) {
      return error
    }
  },
  async searchRegistro({ commit }, search) {
    try {
      const result = await atendimentosService.searchRegistro(search)
      return result
    } catch (error) {
      return error
    }
  },

  getAgendaProfissional({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getAgendaProfissional(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },

  gerarHorarioPorIdAgenda({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .gerarHorarioPorIdAgenda(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },

  getAtendimentoById({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getAtendimentoById(id)
        .then((result) => {
          commit('PREPARE_TO_EDIT_ATENDIMENTO', result.data)
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  getListaProcedimentoPorIdProcedimento({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getListaProcedimentoPorIdProcedimento(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  getListaCamposAtendimentoPorIdAtendimento({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getListaCamposAtendimentoPorIdAtendimento(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  getListaProcedimentosPorEspecialidade({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getListaProcedimentosPorEspecialidade(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  editCamposAdicionais({ commit }, data) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .editCamposAdicionais(data)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  getListaCampoAdicionaisPorIdAtendimento({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getListaCampoAdicionaisPorIdAtendimento(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },

  montarTela({ commit }, id) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .montarTela(id)
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  },
  getComboSituacao({ commit }) {
    return new Promise((resolve, reject) =>
      atendimentosService
        .getComboSituacao()
        .then((result) => {
          resolve(result)
        })
        .catch((err) => reject(err))
    )
  }
}
